// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1RvCp","tab":"ProcedureTabs_tab__1O7vA"};